<script setup lang="ts">
import {computed} from "vue"
import {Price} from "~app/stripe";
import {formatCurrencyUSDWholeDollars} from "@/common/utils/l10n";

const props = withDefaults(
  defineProps<{
    email: string
    price: Price
    label?: string
    variant?: string
  }>(),
  {
    label: undefined,
    variant: 'success',
  },
)

const btnClass = computed(() => [`btn-${props.variant}`])

// payment link may be set on the price or the product
const paymentLink = computed(() => {
  const link = props.price.metadata['payment_link'] ?? props.price.product.metadata['payment_link']
  if (!link) {
    console.warn("No payment link found in price or product.  Link disabled", props.price)
    return '#'
  }
  const email = encodeURI(props.email)
  return `${link}?locked_prefilled_email=${email}`
})

const buttonLabel = computed(() => {
  if (props.label) return props.label
  const displayAmount = formatCurrencyUSDWholeDollars(props.price.unit_amount / 100)
  const period = (props.price.metadata.one_time_purchase === 'true') ? '' : (props.price.recurring?.interval ?? '')
  const displayPeriod = ['year', 'month'].includes(period) ? `per ${period}` : ''
  return `Purchase for ${displayAmount} ${displayPeriod}`
})

function beginCheckout(): void {
  window.open(paymentLink.value)
}

</script>

<template>
  <div class="subscribe-button">
    <button class="btn btn-block btn-lg" :class="btnClass" @click="beginCheckout">
      {{ buttonLabel }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
button {
  font-weight: bold;
  font-size: 125%;
  height: 3rem;
}
</style>
